module.exports = __webpack_public_path__ + "static/img/phone.627f337d.png";